// extracted by mini-css-extract-plugin
module.exports = {"retagIcon":"RetagArtistModalContent-retagIcon-1kCls","message":"RetagArtistModalContent-message-29lIN"};